export const mergeByProp = <T extends Record<string, unknown>>(
  entities: T[],
  mergeProp: string
): T[] => {
  return [...new Map(entities.map((entity) => [entity[mergeProp], entity])).values()];
};
